import React from "react";
import CustomButton from "../../commonComponents/button";
import useLang from "../../../hooks/useLang";

const TaskDeleteDialog = ({ onClose, confirmCallback }) => {
  const [lang] = useLang();

  const [isLoading, setIsLoading] = React.useState(false);

  const handleDelete = async () => {
    setIsLoading(true);
    try {
      await confirmCallback();
      onClose();
    } catch (error) {
      console.error("Error deleting tasks:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <p className="text-[#000000E0] mb-5 mt-3 text-sm font-normal">
        {lang.thisActionCantBeUndone}
      </p>
      <div className="flex justify-start gap-3 items-center">
        <CustomButton
          type="primary"
          danger
          btnText={lang.deleteTasks}
          loading={isLoading}
          handleClick={handleDelete}
        />
        <CustomButton btnText={lang.cancel} handleClick={onClose} />
      </div>
    </div>
  );
};

export default TaskDeleteDialog;
